module.exports = __webpack_public_path__ + "images/redXCircle-3bb91f72c13e06b3193a97e1dfe6942f.svg";